import { render, staticRenderFns } from "./TabContentRowView.vue?vue&type=template&id=0053184a"
import script from "./TabContentRowView.vue?vue&type=script&lang=ts"
export * from "./TabContentRowView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports